<template>
  <div :class="containerClass">
    <input
      type="checkbox"
      name=""
      :id="id"
      :checked="value"
      @click="updateInput"
      :disabled="disabled"
      ref="checkbox"
    >
    <label
      :for="id"
      :class="[checkboxClass, {'Checkbox--indeterminate': indeterminate}]"
    >
      <span
        class="checkbox"
        :class="[labelClass, {'disabled-checkbox' :disabled} ]"
      ></span>
      <slot name="input-label"></slot>
    </label>

  </div>

</template>

<script>
export default {
  name: 'InputCheckbox',
  props: {
    id: {
      type: String
    },
    label: {
      type: String
    },
    name: {
      type: String
    },
    value: {
      type: [String, Number, Boolean, Object]
    },
    updateOnChange: {
      type: Boolean,
      default: false
    },
    labelClass: {
      type: String,
      default: 'Label Label--form'
    },
    containerClass: {
      type: String,
      default: 'd-flex align-items-center'
    },
    extraInfo: {
      type: String,
      default: ''
    },
    checkboxClass: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    preventOnUnchecked: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updateInput (event) {
      if (this.updateOnChange) {
        this.$emit('change', !this.value)
        event.preventDefault()
      } else {
        this.$emit('update:value', !this.value)
        this.$emit('click', !this.value)
      }
    }

  }

}
</script>
<style scoped lang="scss">
.tree {
  input[type="checkbox"]:checked + label span.checkbox {
    background: var(--semantic-brand-main)
      url("~@/assets/img/icons/icon-checkbox-tree.svg") no-repeat center;
    background-size: 10px 2px;
    background-position: center;
    border: 1px solid var(--semantic-brand-main);
  }
}
.label-tree,
.label-tree-normal {
  margin-left: 8px;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  color: var(--text-body);
}
.label-tree-normal {
  font-weight: 400;
}
input[type="checkbox"] {
  display: none;
}
input[type="checkbox"] + label {
  margin-bottom: 0px;
}
input[type="checkbox"] + label span.checkbox {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 1px solid var(--gray-light);
  border-radius: 3px;
  background-color: var(--fill-text-area);
  vertical-align: middle;
}

input[type="checkbox"]:checked + label span.checkbox {
  background: var(--semantic-brand-main)
    url("~@/assets/img/icons/icon-checkbox-checked.svg") no-repeat center;
  background-size: 8.75px 6.51px;
  background-position: center;
  border: 1px solid var(--semantic-brand-main);
}

input[type="checkbox"]:checked + .Checkbox--red span.checkbox {
  background: var(--semantic-negative-main)
    url("~@/assets/img/icons/icon-checkbox-checked.svg") no-repeat center;
  border: 1px solid var(--semantic-negative-main);
}

input[type="checkbox"]:checked + .Checkbox--orange span.checkbox {
  background: var(--semantic-alert-main)
    url("~@/assets/img/icons/icon-checkbox-checked.svg") no-repeat center;
  border: 1px solid var(--semantic-alert-main);
}
input[type="checkbox"]:checked + .Checkbox--purple span.checkbox {
  background: var(--not-valid-purple-1)
    url("~@/assets/img/icons/icon-checkbox-checked.svg") no-repeat center;
  border: 1px solid var(--not-valid-purple-1);
}
input[type="checkbox"]:checked + .Checkbox--green span.checkbox {
  background: var(--semantic-positive-main)
    url("~@/assets/img/icons/icon-checkbox-checked.svg") no-repeat center;
  border: 1px solid var(--semantic-positive-main);
}

input[type="checkbox"] + .Checkbox--indeterminate span.checkbox {
  background: var(--semantic-brand-main)
    url("~@/assets/img/icons/icon-check-indeterminate.svg") no-repeat center;
  border: 1px solid var(--semantic-positive-main);
}

.disabled-checkbox {
  border: 1px solid var(--action-disabled) !important;
}
</style>
